// src/layouts/EmployeeLayout.js
// Minimal shell for the field-employee self portal. Deliberately does NOT use
// DashboardLayout (admin sidebar + notification calls an employee token is 403'd
// from). Just a brand bar + logout and the page content.
import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FaHardHat, FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from '../modules/auth/AuthContext';

const Bar = styled.header`
  height: 60px; display: flex; align-items: center; justify-content: space-between;
  padding: 0 ${(p) => p.theme.spacing(3)};
  background: ${(p) => p.theme.colors.surface};
  border-bottom: 1px solid ${(p) => p.theme.colors.inputGray}33;
  position: sticky; top: 0; z-index: 10;
`;
const Brand = styled.div`
  display: flex; align-items: center; gap: 10px;
  color: ${(p) => p.theme.colors.primary}; font-weight: 700; font-size: 1.1rem;
`;
const LogoutBtn = styled.button`
  display: flex; align-items: center; gap: 8px;
  background: none; border: 1px solid ${(p) => p.theme.colors.inputGray};
  color: ${(p) => p.theme.colors.textPrimary}; border-radius: ${(p) => p.theme.borderRadius};
  padding: ${(p) => p.theme.spacing(1)} ${(p) => p.theme.spacing(2)}; cursor: pointer;
  &:hover { border-color: ${(p) => p.theme.colors.primary}; color: ${(p) => p.theme.colors.primary}; }
`;
const Main = styled.main`
  max-width: 820px; margin: 0 auto; padding: ${(p) => p.theme.spacing(3)};
  @media (max-width: 640px) { padding: ${(p) => p.theme.spacing(2)}; }
`;

const EmployeeLayout = ({ children, title = 'My Time' }) => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ minHeight: '100vh' }}>
      <Bar>
        <Brand><FaHardHat /> {title}</Brand>
        <LogoutBtn onClick={handleLogout}>
          <FaSignOutAlt /> {user?.username ? `Sign out (${user.username})` : 'Sign out'}
        </LogoutBtn>
      </Bar>
      <Main>{children}</Main>
    </div>
  );
};

export default EmployeeLayout;
